/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {motion} from "motion/react";
import {ErrorBoundary} from "errorboundarys";
import CloseButton from "../CloseButton.jsx";

class SmallWindowComponent extends Component {
    render() {
        let {title, children, onClose} = this.props

        return (
            <div className="pointer-events-none fixed inset-0 flex items-end  px-4 py-12 ">
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">

                    <motion.div
                        initial={{x: 60, opacity: 0.4}}
                        animate={{
                            x: 0,
                            opacity: 1
                        }}
                        exit={{
                            x: 60,
                            opacity: 0
                        }}
                        transition={{type: "spring", stiffness: 300, damping: 20, duration: 0.4}}
                        className="pointer-events-auto w-full max-w-lg overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                    >

                        <div className={"flex bg-stone-50 h-11 p-3 items-center"}>
                            <p className="text-sm font-medium text-gray-900 grow">{title}</p>
                            <div className="flex flex-shrink-0">
                                <CloseButton size={"sm"} onClick={() => {
                                    if (onClose !== undefined) {
                                        onClose()
                                    }
                                }}/>
                            </div>
                        </div>
                        <div className="p-4 pt-0">
                            <div className="flex items-start">
                                <div className=" w-0 flex-1 pt-0.5 ">
                                    <div className={"mt-1"}>
                                        <ErrorBoundary errorStyle={'small'}>
                                            {children}
                                        </ErrorBoundary>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>


                </div>
            </div>

        );
    }
}

SmallWindowComponent.propTypes = {};

export default SmallWindowComponent;